import { Box, Text, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ThinEventSession } from '@/resources/ThinEventSession';

import { ScheduleCalendarTooltipLecturesList } from './ScheduleCalendarTooltipLecturesList';

export interface IScheduleCalendarTooltipProps {
  room: string;
  title: string;
  isLive: boolean;
  timeEnd: string;
  session: ThinEventSession;
  timeStart: string;
}

export const ScheduleCalendarTooltip: FC<IScheduleCalendarTooltipProps> = ({
  room,
  title,
  session,
  isLive,
  timeStart,
  timeEnd,
}) => {
  const { t } = useTranslation();
  const shouldShowLectures = session.lecturesCount > 0;

  return (
    <Box py="10px" px="15px" maxH="500px" maxW={{ sm: '320px', md: '700px' }} overflowY="auto" cursor="pointer">
      <Heading as="h3" pb={2} fontSize="lg" fontWeight={'bold'}>
        {title}
      </Heading>
      <Text>{`${timeStart} - ${timeEnd}`}</Text>
      {isLive && (
        <Box
          color="#ef5085"
          fontSize="14px"
          lineHeight="18px"
          _before={{
            content: '""',
            display: 'inline-block',
            width: '12px',
            height: '12px',
            backgroundColor: 'currentColor',
            borderRadius: '50%',
            marginRight: '1ch',
          }}
        >
          {t('live')}
        </Box>
      )}
      <Text fontSize="md">{room}</Text>
      {shouldShowLectures && <ScheduleCalendarTooltipLecturesList sessionId={session.id} />}
    </Box>
  );
};
